import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const rawMaterialApi = createApi({
  reducerPath: "rawMaterialApi",
  baseQuery: appBaseQuery,
  tagTypes: ["RawMaterial"],
  endpoints: (builder) => ({
    getRawMaterials: builder.query({
      query: (params = {}) => buildPagedListUrl("raw-material/", params),
      providesTags: ["RawMaterial"],
    }),
    addRawMaterial: builder.mutation({
      query: (newRawMaterial) => ({
        url: "raw-material/",
        method: "POST",
        body: newRawMaterial,
      }),
      invalidatesTags: ["RawMaterial"],
    }),
    updateRawMaterial: builder.mutation({
      query: ({ uid, ...updatedRawMaterial }) => ({
        url: `raw-material/${uid}`,
        method: "PUT",
        body: updatedRawMaterial,
      }),
      invalidatesTags: ["RawMaterial"],
    }),
    deleteRawMaterial: builder.mutation({
      query: (uid) => ({
        url: `raw-material/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RawMaterial"],
    }),
  }),
});

export const {
  useGetRawMaterialsQuery,
  useLazyGetRawMaterialsQuery,
  useAddRawMaterialMutation,
  useUpdateRawMaterialMutation,
  useDeleteRawMaterialMutation,
} = rawMaterialApi;
